import React from "react";

import { MainContent } from "./MainContent";
import { Translation } from "./Translation";

export function BasketOptions(): JSX.Element {
    return (
        <React.Fragment>
            <MainContent />
            <Translation />
        </React.Fragment>
    );
}
